import type {ReactAction} from '@netx/core/bootstrap';
import {faImages} from '@fortawesome/pro-solid-svg-icons';
import {DownloadRequestActionLabel} from '../locales';
import {type IDownloadRequest} from '../schema';

export const downloadRequestActionViewAssetsIcon = faImages;

export type DownloadRequestActionViewAssetsParams = Partial<
	Omit<ReactAction, 'cb'>
> & {
	cb: (downloadRequest: IDownloadRequest) => void;
};

/**
 * @param params
 * @returns Action
 */
export const downloadRequestActionViewAssets = (
	downloadRequest: IDownloadRequest,
	{cb, ...params}: DownloadRequestActionViewAssetsParams,
): ReactAction => ({
	name: 'download-request-view-assets',
	cb: () => cb(downloadRequest),
	icon: downloadRequestActionViewAssetsIcon,
	label: DownloadRequestActionLabel.VIEW,
	...params,
});
